export const USER_SPEECH_LEVEL_THRESHOLD = 0.05;
export const USER_SPEECH_SUSTAINED_MS = 300;

interface ShouldStopAiOnUserAudioInput {
  isAiVoiceEnabled: boolean;
  isSpeaking: boolean;
  audioLevel: number;
  sustainedStartedAt: number | null;
  now: number;
  threshold?: number;
  sustainedMs?: number;
}

interface ShouldStopAiOnUserAudioResult {
  shouldStop: boolean;
  nextSustainedStartedAt: number | null;
}

export function shouldStopAiOnUserAudio({
  isAiVoiceEnabled,
  isSpeaking,
  audioLevel,
  sustainedStartedAt,
  now,
  threshold = USER_SPEECH_LEVEL_THRESHOLD,
  sustainedMs = USER_SPEECH_SUSTAINED_MS,
}: ShouldStopAiOnUserAudioInput): ShouldStopAiOnUserAudioResult {
  if (!isAiVoiceEnabled || !isSpeaking) {
    return { shouldStop: false, nextSustainedStartedAt: null };
  }
  if (audioLevel <= threshold) {
    return { shouldStop: false, nextSustainedStartedAt: null };
  }
  if (sustainedStartedAt === null) {
    return { shouldStop: false, nextSustainedStartedAt: now };
  }
  if (now - sustainedStartedAt >= sustainedMs) {
    return { shouldStop: true, nextSustainedStartedAt: null };
  }
  return { shouldStop: false, nextSustainedStartedAt: sustainedStartedAt };
}
